module.exports = new __parcel__URL__("alien.b06df88b.jpg").toString();